type FontConfig = {
    fontFamily: string;
    fontWeight: "normal" | "bold"; // Match TextStyleFontWeight
    fontSize: number;
    letterSpacing?: number;
    lineHeight?: number;
};


type TextType = "heading" | "description" | "volatility" | "continue" | "introHeading" | "introDesc1" | "introDesc2" | "introContinue";

const fontConfigs: Record<string, Record<TextType, FontConfig>> = {
    default: {
        heading: {
            fontFamily: "Comic Sans MS",
            fontWeight: "bold",
            fontSize: 36,
            letterSpacing: 1,
            lineHeight: 50,
        },
        description: {
            fontFamily: "Comic Sans MS",
            fontWeight: "normal",
            fontSize: 26,
            letterSpacing: 1,
            lineHeight: 35,
        },
        volatility: {
            fontFamily: "Comic Sans MS",
            fontWeight: "bold",
            fontSize: 22,
        },
        continue: {
            fontFamily: "Comic Sans MS",
            fontWeight: "normal",
            fontSize: 35,
        },
        introHeading: {
            fontFamily: "Comic Sans MS",
            fontWeight: "bold",
            fontSize: 72,
        },
        introDesc1: {
            fontFamily: "Comic Sans MS",
            fontWeight: "bold",
            fontSize: 65,
            lineHeight: 58
        },
        introDesc2: {
            fontFamily: "Comic Sans MS",
            fontWeight: "normal",
            fontSize: 35,
            lineHeight: 38
        },
        introContinue: {
            fontFamily: "Comic Sans MS",
            fontWeight: "normal",
            fontSize: 50,
        },
    },
    en: {
        heading: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 48,
            letterSpacing: 1,
            lineHeight: 50,
        },
        description: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 27,
            letterSpacing: 2,
            lineHeight: 30,
        },
        volatility: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 36,
        },
        continue: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 38,
        },
        introHeading: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 80,
        },
        introDesc1: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 80,
            lineHeight: 50
        },
        introDesc2: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 38,
            lineHeight: 45

        },
        introContinue: {
            fontFamily: "Motley Forces",
            fontWeight: "normal",
            fontSize: 55,
        },

    },

};

export function getFontConfig(language: string, textType: TextType): FontConfig {

    // const asianLanguages = new Set(['zh-cn', 'ko-kr', 'th-th', 'ja-jp', 'vi-vn', 'hu-hu', 'ro-ro', 'sv-se', 'lt-lt', "pl-pl", "da-dk", "pt-pt", "pt-br"]);
    let effectiveLanguage: string;

    if (language === "en-us") {
        effectiveLanguage = "en";
    }
    // else if (asianLanguages.has(language)) {
    //     effectiveLanguage = "asian";
    // } 
    else {
        effectiveLanguage = "default";
    }

    const languageConfig = fontConfigs[effectiveLanguage];
    const textConfig = languageConfig[textType];

    //     else if (["es-es", "ro-ro", "gr-gr"].indexOf(language) !== -1 && textType === 'description') {
    //     textConfig.fontSize = 26;
    //     textConfig.lineHeight = 35;
    //     // textConfig.lineHeight = 38;
    // }


    // special checks
    if (["hu-hu"].indexOf(language) !== -1 && textType === 'description') {
        textConfig.fontSize = 25;
        textConfig.lineHeight = 35;
    }
    else if (["ja-jp"].indexOf(language) !== -1 && textType === 'description') {
        textConfig.fontSize = 24;
        textConfig.lineHeight = 35;
    }
    else if (["lt-lt"].indexOf(language) !== -1 && textType === 'description') {
        textConfig.fontSize = 25;
        textConfig.lineHeight = 27;
    }
    else if (["fr-fr"].indexOf(language) !== -1 && textType === 'introDesc2') {
        textConfig.fontSize = 38;
    }

    // else if (["de-de", "fr-fr", "it-it", "lv-lv", "tr-tr"].indexOf(language) !== -1 && textType === 'volatility') {
    //     textConfig.fontFamily = "Helvetica";
    // }
    // else if (["es-es", "lv-lv", "ru-ru", "tr-tr"].indexOf(language) !== -1 && textType === 'heading') {
    //     textConfig.fontFamily = "Helvetica";
    // }
    // else if (["ru-ru", "tr-tr", "lv-lv"].indexOf(language) !== -1 && textType === 'introHeading') {
    //     textConfig.fontFamily = "Helvetica";
    // }
    // else if (["no-no", "tr-tr", "lv-lv"].indexOf(language) !== -1 && textType === 'continue') {
    //     textConfig.fontFamily = "Helvetica";
    // }
    // else if (["no-no", "tr-tr", "lv-lv"].indexOf(language) !== -1 && textType === 'introContinue') {
    //     textConfig.fontFamily = "Helvetica";
    // }

    // if (["bg-bg"].indexOf(language) !== -1 && textType === 'heading') {
    //     textConfig.fontSize = 30;
    // }


    return textConfig;
}
